import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {FirebaseAuthProvider} from "./context/FirebaseAuthContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <FirebaseAuthProvider>
            <App />
        </FirebaseAuthProvider>
    </React.StrictMode>
);

